/**
 * Created by choizhang on 2018/1/31.
 */
import Vue from 'vue'
import Moment from 'moment'

Vue.filter('formatTime', (time, type) => {
    if (!time) {
        return ''
    }
    if (type) {
        return Moment(time).format(type)
    } else {
        return Moment(Number(time)).format('YYYY-MM-DD HH:mm:ss')
    }
})
Vue.filter('timestamp', (timestamp) => {
    if (!timestamp) {
        return ''
    }
    let date
    if (timestamp.length === 13) {
        date = new Date(Number(timestamp))
    } else {
        date = new Date(timestamp * 1000)
    }
    let Y = date.getFullYear() + '-'
    let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
    let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' '
    let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
    let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes())
    return Y + M + D + h + m
})

Vue.filter('formatSize', (bytes) => {
    if (bytes === 0) return '0 B'
    var k = 1000, // or 1024
        sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        i = Math.floor(Math.log(bytes) / Math.log(k))

    return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i]
})

Vue.filter('decodeURI', (url) => {
    if (url) {
        return decodeURIComponent(url)
    }
    return ''
})



// WEBPACK FOOTER //
// ./src/util/filters.js